(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('InformeFormController', InformeFormController);

    testApp.filter('customFilter', function () {
        return function (dataArray, searchTerm) {
            if (!dataArray) {
                return;
            } else if (!searchTerm) {
                return dataArray;
            } else {
                var term = searchTerm.toString().toLowerCase();
                return dataArray.filter(function (item) {
                    var termNombre = false,
                        termId = false,
                        termDescripcion = false,
                        termValue = false;
                    if (item.nombre != undefined) termNombre = item.nombre.toLowerCase().indexOf(term) > -1;
                    if (item.descripcion != undefined) termDescripcion = item.descripcion.toLowerCase().indexOf(term) > -1;
                    if (item.value != undefined && (typeof item.value === 'string')) termValue = item.value.toLowerCase().indexOf(term) > -1;

                    return termNombre || termId || termDescripcion || termValue;
                });
            }
        }
    });

    InformeFormController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'reportService', 'notificationService', 'reportingService', 'endPoints', 'common', 'userService', 'simpleModalService'
    ];


    function InformeFormController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, reportService, notificationService, reportingService, endPoints, common, userService,simpleModalService) {

        /* PUBLIC VARIABLES */
        var vm = this;
        var id = $stateParams.id;
        vm.predeterminated = false;
        vm.report = {};
        vm.adaptedFilters = [];
        vm.stablished = null;
        vm.loadingInformation = true; //es contrario
        vm.exportOption = {
            id: 2, 
            description: 'PDF'
        };

        vm.meses = {
            list: [
            {
                id: 12,
                nombre: 'Todos',
                selected: false
            },
            {
                id: 0, 
                nombre: 'Enero', 
                selected: false
            }, {
                id: 1,
                nombre: 'Febrero',
                selected: false
            }, {
                id: 2,
                nombre: 'Marzo',
                selected: false
            }, {
                id: 3,
                nombre: 'Abril',
                selected: false
            }, {
                id: 4,
                nombre: 'Mayo',
                selected: false
            }, {
                id: 5,
                nombre: 'Junio',
                selected: false
            }, {
                id: 6,
                nombre: 'Julio',
                selected: false
            }, {
                id: 7,
                nombre: 'Agosto',
                selected: false
            }, {
                id: 8,
                nombre: 'Septiembre',
                selected: false
            }, {
                id: 9,
                nombre: 'Octubre',
                selected: false
            }, {
                id: 10,
                nombre: 'Noviembre',
                selected: false
            }, {
                id: 11,
                nombre: 'Diciembre',
                selected: false
            }], 
            selected: []
        }; 
        vm.anos = {list: [],
            selected: 0
        };

        vm.empleados = {
            list: [],
            selected: null
        }; 

        vm.filtersSelected = [];
        vm.masFiltros = false;
        vm.dateFilter = $.extend({}, common.defaultDateRangePickerOptions);
        vm.dateFilter.fromDate = moment().subtract(1, 'years');
        vm.dateFilter.toDate = moment();
        vm.filtroFlota = {};
        vm.bitwise = [{
                id: 0,
                nombre: 'ninguno'
            },
            {
                id: 1,
                nombre: '=', 
                caption: 'igual a'
            },
            {
                id: 2,
                nombre: '>',
                caption: 'mayor a'
            },
            {
                id: 4,
                nombre: '<',
                caption: 'menor a'
            },
            {
                id: 8,
                nombre: '!=',
                caption: 'diferente de'
            },
            {
                id: 16,
                nombre: 'between',
                caption: 'entre'
            },
            {
                id: 32,
                nombre: 'in',
                caption: 'contiene'
            }
        ];
        vm.graphs = [];
        vm.disablebuttonfilter = true; 
       

        vm.sendErrorRequire = sendErrorRequire;
        vm.print = print;
        vm.exportReport = exportReport;
        vm.filtrarReport = filtrarReport;
        vm.addFilter = addFilter;
        vm.addFrequentItem = addFrequentItem;
        vm.addFrequentItemFlota = addFrequentItemFlota;
        vm.removeFilter = removeFilter;
        vm.changeGraph = changeGraph;
        vm.expandMasFiltros = expandMasFiltros;
        vm.openList = openList;
        vm.showFichaje = showFichaje; 
        vm.addMes = addMes; 
        vm.showServicios = showServicios; 
        

        (function () {
            loadData();
        })();

        function loadData() {
            reportingService.getById(id).then(function (response) {
                vm.predeterminated = response.data.empresaMasterId == null;
                vm.report = response.data;
                if (vm.predeterminated == false) {
                    vm.loadingInformation = false;
                    reportingService.showReport(id).then(function (response) {
                        $('#report-container').html(response.data);
                        vm.loadingInformation = true;
                    });
                } else {
                    if(vm.report.grupoId != 3) vm.loadingInformation = false;
                    if(vm.report.name == 'Servicios por día') {
                        reportingService.getEmpresas().then(function(result){
                            vm.empresas.list = result.data;
                            vm.empresas.list.unshift({nombre:'Todas', id:'00000000-0000-0000-0000-000000000000'}); 
                            vm.empresas.selected = vm.empresas.list[0]; 
                            setGraphs(); 
                            vm.dateFilter.fromDate = moment().subtract(7, 'days');
                            vm.dateFilter.toDate = moment();
                            vm.showServicios(); 
                        });
                    }
                    else if (vm.report.grupoId == 4) {
                        if (userService.userData.empresamaster.contrataControlHorario != true) $state.go('flota.controlHorario.activarControlHorario');

                        reportingService.getEmpleados().then(function (result) {
                            vm.empleados.list.push({
                                nombre: 'Todos',
                                id: '00000000-0000-0000-0000-000000000000'
                            })
                            for (var i = 0; i < result.data.length; i++) {
                                vm.empleados.list.push({
                                    nombre: result.data[i].nombre + ' ' + result.data[i].apellidos,
                                    id: result.data[i].empleadoId
                                });
                            }
                            vm.empleados.selected = vm.empleados.list[0];
                            vm.dateFilter.toDate = moment(); 
                            vm.dateFilter.fromDate = moment().subtract(7, 'days');
                            vm.showFichaje();
                        });
                    }
                    else {
                        setGraphs();
                        if (vm.report.grupoId != 3) {
                            adaptDateFilter();
                            filtrarReportIni();
                        }
                        reportingService.getPredeterminatedFilters(id).then(function (response) {
                            vm.filters = response.data;
                            if (vm.report.grupoId == 3) {
                                vm.dateFilter.fromDate = moment().subtract(7, 'days');
                                vm.dateFilter.toDate = moment();
                                vm.filtroFlota = vm.filters[0];
                                vm.filtroFlota.dataArray = 0;
                                vm.filtroFlota.text = '';
                                vm.filtroFlota.totalGrupos = 0;
                                var count = 0;
                                if (vm.filtroFlota.data.length == 0) {
                                    vm.loadingInformation = true;
                                    //sendErrorRequire('No tiene ningún vehículo con datos válidos');
                                    //return;

                                    $state.go('flota.informes.nopremium', {
                                        'id': id
                                    });
                                    return;

                                }
                                for (var i = 0; i < vm.filtroFlota.data.length; i++) {
                                    vm.filtroFlota.data[i].group = false;
                                    vm.filtroFlota.data[i].show = true; 
                                    vm.filtroFlota.data[i].selected = false;

                                    if (i == 0 || (vm.filtroFlota.data[i].groupBy != vm.filtroFlota.data[i - 1].groupBy)) {
                                        vm.filtroFlota.data.splice(i, 0, {
                                            nombre: vm.filtroFlota.data[i].groupBy,
                                            value: '0',
                                            group: true,
                                            show: true,
                                            selected: 0
                                        });
                                        ++i;
                                        if (i != 1) {
                                            vm.filtroFlota.data[count].value = i - count - 2;
                                            count = i - 1;
                                        }
                                    }
                                    if (i == vm.filtroFlota.data.length - 1) {
                                        vm.filtroFlota.data[count].value = vm.filtroFlota.data.length - count - 1;
                                    }
                                }
                                for (var j = 0; j < vm.filtroFlota.data.length; ++j) {
                                    if (vm.filtroFlota.data[j].group == true) {
                                        vm.filtroFlota.totalGrupos += 1;
                                        vm.addFrequentItemFlota(vm.filtroFlota.data[j]);
                                    }
                                }

                                vm.filtrarReport(); 
                            } 
                               
                            else {
                                setFilters();
                            }
                            vm.disablebuttonfilter = false; 
                            //if(vm.report.grupoId != 3) filtrarReport();
                        });
                    }
                    


                }
            });
        }

        function setGraphs() {
            var count = vm.report.graph;
            var times = 0;
            while (count != 0) {
                if ((count & Math.pow(2, times)) == Math.pow(2, times)) {
                    vm.graphs.push(Math.pow(2, times));
                    count -= Math.pow(2, times);
                }
                times++;
            }
            vm.stablished = vm.graphs[0];
        }

        function openList(e) {
            $(e.currentTarget).siblings("div").toggle(); 
            e.stopPropagation(); 
        }

        function setFilters() {

            for (var j = 0; j < vm.filters.length; j++) {
                vm.filters[j].operators = [];
                vm.bitwise.forEach(function (bit) {
                    if (bit.id != 0 && (vm.filters[j].bitwise & bit.id) == bit.id) {
                        vm.filters[j].operators.push(bit);
                    }
                });
                if (vm.filters[j].dataType == 'guid') {
                    var count = 0;
                    for (var i = 0; i < vm.filters[j].data.length; i++) {
                        vm.filters[j].data[i].group = false;
                        if(vm.filters[j].columnExtendedId != 314) vm.filters[j].data[i].show = true;
                        else vm.filters[j].data[i].show = false;
                        vm.filters[j].data[i].selected = false;

                        if (i == 0 || (vm.filters[j].data[i].groupBy != vm.filters[j].data[i - 1].groupBy)) {
                            vm.filters[j].data.splice(i, 0, {
                                nombre: vm.filters[j].data[i].groupBy,
                                value: '0',
                                group: true,
                                show: true,
                                selected: 0
                            });
                            ++i;
                            if (i != 1) {
                                vm.filters[j].data[count].value = i - count - 2;
                                count = i - 1;
                            }
                        }
                        if (i == vm.filters[j].data.length - 1) {
                            vm.filters[j].data[count].value = vm.filters[j].data.length - count - 1;
                        }
                    }
                }
            }
        }

        function sendErrorRequire(messageValue) {
            notificationService.sendAppNotification({
                message: messageValue,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'error'
            });
        }

        function print() {

        }

        function exportReport(type) {

            vm.exportOption.id = type; 
            vm.exportOption.description = type == 0 ? 'CSV' : type == 1 ? 'Excel' : 'PDF';
             if(vm.report.name == 'Servicios por día') {
                vm.loadingInformation = false; 
                reportingService.exportServicios(vm.dateFilter.fromDate, vm.dateFilter.toDate, type, vm.empresas.selected.id).then(function(response) {
                    var file;
                    if (type == 0) {
                        file = new Blob([response.data], {
                            type: 'application/octet-stream'
                        });
                        saveAs(file, vm.report.name.trim() + '.csv');

                    } else if (type == 1) {
                        file = new Blob([response.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        saveAs(file, vm.report.name.trim() + '.xlsx');
                    } else {
                        file = new Blob([response.data], {
                            type: 'application/pdf'
                        });
                        saveAs(file, vm.report.name.trim() + '.pdf');

                    }
                    vm.loadingInformation = true;
                });
            }
            else if(vm.report.grupoId != 4) {
                vm.loadingInformation = false;
                reportingService.exportReport(vm.report.id, type, vm.adaptedFilters).then(function (response) {
                    var file;
                    if (type == 0) {
                        file = new Blob([response.data], {
                            type: 'application/octet-stream'
                        });
                        saveAs(file, vm.report.name.trim() + '.csv');

                    } else if (type == 1) {
                        file = new Blob([response.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        saveAs(file, vm.report.name.trim() + '.xlsx');
                    } else {
                        file = new Blob([response.data], {
                            type: 'application/pdf'
                        });
                        saveAs(file, vm.report.name.trim() + '.pdf');

                    }
                    vm.loadingInformation = true;


                });
            }
            else if(vm.report.grupoId == 4) {
                if (common.isNullOrUndefined(vm.dateFilter.fromDate) || common.isNullOrUndefined(vm.dateFilter.toDate) || vm.empleados.selected == null || vm.dateFilter.fromDate > vm.dateFilter.toDate) {
                    sendErrorRequire('Los filtros no están completos!');
                } else {
                    simpleModalService
                    .twoOptionsModal('Exportar a '+ vm.exportOption.description) 
                    .then(function (result) {
                        if(result == 0) return; 
                        if (result == "extendido") { 
                            type+=3; 
                        }
                        vm.loadingInformation = false;
                        //  var date = new Date(vm.anos.selected.id, vm.meses.selected.id);
                        reportingService.exportFichaje(vm.empleados.selected.id, vm.dateFilter.fromDate, vm.dateFilter.toDate, type).then(function (response) {
                            var file;
                            if (type == 1 || type == 0 || type==3 ||type==4) {
                                file = new Blob([response.data], {
                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                });
                                saveAs(file, vm.report.name.trim() + '.xlsx');
                            } else {
                                file = new Blob([response.data], {
                                    type: 'application/pdf'
                                });
                                saveAs(file, vm.report.name.trim() + '.pdf');

                            }
                            vm.loadingInformation = true;
                        });
                    });
                }
            }
           
        }

        function filtrarReportIni()  {
             vm.loadingInformation = false;
             if (id == 20) {
                  var filters = [];
                  var filterDate = {
                      id: 403,
                      operando: 'between',
                      value: null
                  }
                  var dateTimeFrom = new Date(vm.dateFilter.fromDate);
                  var dateTimeTo = new Date(vm.dateFilter.toDate);
                  var string = moment(dateTimeFrom).format('YYYYMMDD');
                  string += moment(dateTimeTo).format('YYYYMMDD');
                  filterDate.value = string;
                  filters.push(filterDate);
                  vm.adaptedFilters = filters; 
                 reportingService.showFacturasCliente(id, filters).then(function (response) {
                     $('#report-container').html(response.data);
                     if (vm.stablished == 1) drawColumn();
                     else if (vm.stablished == 2) drawCheese();
                     else if (vm.stablished == 4) drawLine();
                     vm.loadingInformation = true;
                 });
             }  else {
                    var filters = [];
                    var filterDate = {
                        id: 316,
                        operando: 'between',
                        value: null
                    }
                    var dateTimeFrom = new Date(vm.dateFilter.fromDate);
                    var dateTimeTo = new Date(vm.dateFilter.toDate);
                    var string = moment(dateTimeFrom).format('YYYYMMDD');
                    string += moment(dateTimeTo).format('YYYYMMDD');
                    filterDate.value = string;
                    filters.push(filterDate);
                    vm.adaptedFilters = filters;
                    reportingService.showPredeterminated(id, filters).then(function (response) {
                        $('#report-container').html(response.data);
                        if (vm.stablished == 1) drawColumn();
                        else if (vm.stablished == 2) drawCheese();
                        else if (vm.stablished == 4) drawLine();
                        vm.loadingInformation = true;
                    });
             }
        }

        function filtrarReport() {
            if (checkFilters() == 1) {
                sendErrorRequire('Los filtros no están completos!');
            } else {
                vm.adaptedFilters = adaptFilters();
                vm.loadingInformation = false;
                if (id == 20) {
                    reportingService.showFacturasCliente(id, vm.adaptedFilters).then(function (response) {
                        $('#report-container').html(response.data);
                        if (vm.stablished == 1) drawColumn();
                        else if (vm.stablished == 2) drawCheese();
                        else if (vm.stablished == 4) drawLine();
                        vm.loadingInformation = true;
                    });
                } else if (id == 27) {
                    if(vm.adaptedFilters[1].length == 0) {
                        sendErrorRequire('Los filtros no están completos!'); 
                        vm.loadingInformation = true;
                        return; 
                    }
                    reportingService.consumoCombustible(vm.adaptedFilters[0], vm.adaptedFilters[1]).then(function (response) {
                        $('#report-container').html(response.data);
                        vm.loadingInformation = true;
                        drawGraph();
                    });

                    } else if (id == 28) {
                            if (vm.adaptedFilters[1].length == 0) {
                                sendErrorRequire('Los filtros no están completos!');
                                vm.loadingInformation = true;
                                return;
                            }
                        reportingService.combustibleRespectoTotal(vm.adaptedFilters[0], vm.adaptedFilters[1]).then(function (response) {
                        $('#report-container').html(response.data);
                        vm.loadingInformation = true;
                        drawGraph();
                    });
                } else {
                    reportingService.showPredeterminated(id, vm.adaptedFilters).then(function (response) {
                        $('#report-container').html(response.data);
                        if (vm.stablished == 1) drawColumn();
                        else if (vm.stablished == 2) drawCheese();
                        else if (vm.stablished == 4) drawLine();
                        vm.loadingInformation = true;
                    });
                }

            }

        }

         function showFichaje() {
            vm.loadingInformation = false;
             if (common.isNullOrUndefined(vm.dateFilter.fromDate) || common.isNullOrUndefined(vm.dateFilter.toDate) || vm.empleados.selected == null || vm.dateFilter.fromDate > vm.dateFilter.toDate) {
                 sendErrorRequire('Los filtros no están completos!');
             } else {
                reportingService.showFichaje(vm.empleados.selected.id, vm.dateFilter.fromDate, vm.dateFilter.toDate).then(function (response) {
                    $('#report-container').html(response.data);
                    vm.loadingInformation = true;
                    drawGraph();
                });
            } 
         }

         function showServicios() {
             vm.loadingInformation = false; 
             reportingService.showServicios(vm.dateFilter.fromDate, vm.dateFilter.toDate, vm.empresas.selected.id).then(function(response){
                $('#report-container').html(response.data);
                vm.loadingInformation = true;
                drawColumn();
            }); 
         }

        function changeGraph(val) {
            if (val != vm.stablished) {
                vm.stablished = val;
                if (vm.stablished == 1) drawColumn();
                else if (vm.stablished == 2) drawCheese();
                else if (vm.stablished == 4) drawLine();
            }
        }

        function checkFilters() {
            for (var i = 0; i < vm.filtersSelected.length; i++) {
                if (common.isNullOrUndefined(vm.filtersSelected[i].field)) {
                    vm.filtersSelected.splice(i, 1);
                    i--;
                } else {
                    if (vm.filtersSelected[i].field.dataType == 'guid' && vm.filtersSelected[i].dataArray == 0) return 1;
                    else if (vm.filtersSelected[i].field.data != null && common.isNullOrUndefined(vm.filtersSelected[i].data)) return 1;
                    else if (common.isNullOrUndefined(vm.filtersSelected[i].data)) return 1;
                }
            }
            return 0;
        }

        function adaptDateFilter() {
            if(vm.report.id == 24) { //diferencia kms
                vm.dateFilter.fromDate = moment().startOf('year');
                vm.dateFilter.toDate = moment();
            }
        }

        function adaptFilters() {
            var filters = [];
            if (vm.report.grupoId == 3) {
                var dateTimeFrom = new Date(vm.dateFilter.fromDate);
                var dateTimeTo = new Date(vm.dateFilter.toDate);
                var string = moment(dateTimeFrom).format('YYYYMMDD');
                string += moment(dateTimeTo).format('YYYYMMDD');
                var list = [];
                for (var i = 0; i < vm.filtroFlota.data.length; ++i) {
                    if (vm.filtroFlota.data[i].selected == true && vm.filtroFlota.data[i].group == false) {
                        list.push(vm.filtroFlota.data[i].id);
                    }
                }
                filters.push(list);
                return [string, list];
            }
            var temp = vm.filters.find(x => (x.dataType == 'datetime' || x.dataType == 'date') && x.tableId == vm.report.mainTable);
            var filterDate = {
                id: temp.columnExtendedId,
                operando: 'between',
                value: null
            }
            var dateTimeFrom = new Date(vm.dateFilter.fromDate);
            var dateTimeTo = new Date(vm.dateFilter.toDate);
            var string = moment(dateTimeFrom).format('YYYYMMDD');
            string += moment(dateTimeTo).format('YYYYMMDD');
            filterDate.value = string;
            filters.push(filterDate);

            for (var i = 0; i < vm.filtersSelected.length; i++) {
                var filter = {
                    id: null,
                    operando: '',
                    value: ''
                }
                filter.id = vm.filtersSelected[i].field.columnExtendedId;
                if (vm.filtersSelected[i].field.dataType == 'guid') {
                    filter.operando = 'in';
                    for (var j = 0; j < vm.filtersSelected[i].field.data.length; j++) {
                        if (vm.filtersSelected[i].field.data[j].selected == true && vm.filtersSelected[i].field.data[j].group == false) {
                            filter.value += vm.filtersSelected[i].field.data[j].id + ';';
                        }
                    }
                    filter.value = filter.value.slice(0, -1);
                } else if (vm.filtersSelected[i].field.data != null) {
                    filter.operando = vm.filtersSelected[i].operator.nombre;
                    filter.value = vm.filtersSelected[i].data.value;

                } else {
                    filter.operando = vm.filtersSelected[i].operator.nombre;
                    filter.value = vm.filtersSelected[i].data;
                }
                filters.push(filter);
            }
            return filters;
        }

        function addFilter() {
            var filter = {
                fieldId: null,
                data: "",
                operator: null,
                dataArray: 0,
                dateRange: $.extend({}, common.defaultDateRangePickerOptions),
                text: ''
            };
            vm.filtersSelected.push(filter);
        }

        function expandMasFiltros() {
            if (vm.masFiltros == false && vm.filtersSelected.length == 0) {
                vm.addFilter();
            }
            vm.masFiltros = !vm.masFiltros; 
        }

        function removeFilter(index) {
            if(vm.filtersSelected[index].field.dataType == 'guid') {
                for(var i = 0; i < vm.filtersSelected[index].field.data.length; i++) {
                    if (vm.filtersSelected[index].field.data[i].group == true) vm.filtersSelected[index].field.data[i].selected = 0;
                    else vm.filtersSelected[index].field.data[i].selected = false; 
                }
            }
            vm.filtersSelected.splice(index, 1);
        }

        function addMes(option) {
            if(option.id == 12) {
                if(option.selected == true) {
                    option.selected = false; 
                    vm.meses.selected = []; 
                    for (var i = 0; i < vm.meses.list.length; ++i) {
                        vm.meses.list[i].selected = false;
                    }
                }
                else {
                    option.selected = true; 
                    vm.meses.selected = [];
                    for (var i = 1; i < vm.meses.list.length; ++i) {
                        vm.meses.list[i].selected = true;
                        vm.meses.selected.push(vm.meses.list[i].id); 
                    }
                }
                
                
            }
            else {
                if (option.selected == true) {
                    if(vm.meses.list[0].selected == true) vm.meses.list[0].selected = false; 
                    option.selected = false;
                    var idx = vm.meses.selected.findIndex(x => x == option.id);
                    if (idx > -1) {
                        vm.meses.selected.splice(idx, 1);
                    }
                } else {
                    option.selected = true;
                    vm.meses.selected.push(option.id);
                    if (vm.meses.selected.length == 12) vm.meses.list[0].selected = false;

                }
            }
        }

        function addFrequentItem(item, option) {
            if (option.group == false) {
                if (option.selected == false) {
                    option.show = true;
                    option.selected = true;
                    item.dataArray += 1;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == true && item.field.data[i].nombre == option.groupBy) {
                            item.field.data[i].selected += 1;
                            if (item.field.data[i].selected == item.field.data[i].value) {
                                for (var j = 0; j < item.field.data.length; j++) {
                                    if (item.field.data[j].group == false && item.field.data[j].groupBy == item.field.data[i].nombre) {
                                        item.field.data[j].show = false;
                                    }
                                }
                            }
                            break;
                        }
                    }
                } else {
                    item.dataArray -= 1;
                    if(item.field.columnExtendedId == 314) option.show = false;
                    option.selected = false;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == true && (item.field.data[i].nombre == option.groupBy)) {
                            item.field.data[i].selected -= 1;
                            if (item.field.data[i].selected == (item.field.data[i].value - 1)) {
                                for (var j = 0; j < item.field.data.length; j++) {
                                    if ((item.field.data[j].group == false) && (item.field.data[j].groupBy == item.field.data[i].nombre) && (item.field.data[j].selected == true)) {
                                        item.field.data[j].show = true;
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
            } else {
                if (option.selected != option.value) {
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (option.nombre == item.field.data[i].groupBy) {
                            if (item.field.data[i].selected == false) {
                                option.selected += 1;
                                item.dataArray += 1;
                                item.field.data[i].selected = true;
                            }
                            if (item.field.columnExtendedId == 314) item.field.data[i].show = false;
                        }
                    }

                } else {

                    option.selected = 0;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == false && item.field.data[i].groupBy == option.nombre) {
                            if (item.field.columnExtendedId == 314)item.field.data[i].show = false;
                            item.field.data[i].selected = false;
                            item.dataArray -= 1;
                        }
                    }
                }

            }

        }

        function addFrequentItemFlota(option) {
            if (option.group == false) {
                if (option.selected == false) {
                    option.show = true;
                    option.selected = true;
                    vm.filtroFlota.dataArray += 1;
                    for (var i = 0; i < vm.filtroFlota.data.length; i++) {
                        if (vm.filtroFlota.data[i].group == true && vm.filtroFlota.data[i].nombre == option.groupBy) {
                            vm.filtroFlota.data[i].selected += 1;
                            if (vm.filtroFlota.data[i].selected == vm.filtroFlota.data[i].value) {
                                for (var j = 0; j < vm.filtroFlota.data.length; j++) {
                                    if (vm.filtroFlota.data[j].group == false && vm.filtroFlota.data[j].groupBy == vm.filtroFlota.data[i].nombre) {
                                        vm.filtroFlota.data[j].show = false;
                                    }
                                }
                            }
                            break;
                        }
                    }
                } else {
                    vm.filtroFlota.dataArray -= 1;
                    option.selected = false;
                    for (var i = 0; i < vm.filtroFlota.data.length; i++) {
                        if (vm.filtroFlota.data[i].group == true && (vm.filtroFlota.data[i].nombre == option.groupBy)) {
                            vm.filtroFlota.data[i].selected -= 1;
                            if (vm.filtroFlota.data[i].selected == (vm.filtroFlota.data[i].value - 1)) {
                                for (var j = 0; j < vm.filtroFlota.data.length; j++) {
                                    if ((vm.filtroFlota.data[j].group == false) && (vm.filtroFlota.data[j].groupBy == vm.filtroFlota.data[i].nombre) && (vm.filtroFlota.data[j].selected == true)) {
                                        vm.filtroFlota.data[j].show = true;
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
            } else {
                if (option.selected != option.value) {
                    for (var i = 0; i < vm.filtroFlota.data.length; i++) {
                        if (option.nombre == vm.filtroFlota.data[i].groupBy) {
                            if (vm.filtroFlota.data[i].selected == false) {
                                option.selected += 1;
                                vm.filtroFlota.dataArray += 1;
                                vm.filtroFlota.data[i].selected = true;
                            }
                        }
                    }

                } else {
                    option.selected = 0;
                    for (var i = 0; i < vm.filtroFlota.data.length; i++) {
                        if (vm.filtroFlota.data[i].group == false && vm.filtroFlota.data[i].groupBy == option.nombre) {
                            vm.filtroFlota.data[i].selected = false;
                            vm.filtroFlota.dataArray -= 1;
                        }
                    }
                }

            }
        }

    }
})();
